export const NoEligibleInstances = () => (
  <div className="flex">
    <span className="n-body-large text-palette-neutral-text-default" data-testid="no-eligible-instances-message">
      You have no eligible instances for metrics integration.
    </span>
  </div>
);
